import { Subscriber } from '@opentok/client';
import { getMediaStats, MediaStats } from '../../utils';

export class SubscriberStats {
  private lastReport: RTCStatsReport | undefined;

  constructor(private readonly subscriber: Subscriber) {}

  async getStats(): Promise<MediaStats | undefined> {
    try {
      const raw = await this.subscriber.getRtcStatsReport();

      const mediaStats = getMediaStats(raw, 'inbound', this.lastReport);

      this.lastReport = raw;

      return mediaStats;
    } catch (error) {
      if (
        error instanceof Error &&
        error.message.includes('PeerConnection not connected')
      ) {
        return undefined;
      }

      throw error;
    }
  }
}
